import { Component, OnInit, Inject, ViewChild, SimpleChanges, HostListener, Input, Directive, Output, EventEmitter, AfterContentInit, AfterViewInit, OnChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { sha256 } from "js-sha256";
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";
import { ErrorStateMatcher } from '@angular/material/core';
import { User } from "../models/user";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VariablesGlobales } from '../services/globals';
import swal from 'sweetalert2';
import { profil } from '../models/profil';
import { AuthService } from '../services/auth.service';
import xml2js from 'xml2js';
import { SlideControlComponent } from 'ng-spc';
import { ControlInput, VertifyQuery } from 'ng-spc';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigService } from '../services/config.service';

declare var $: any;

interface FileReaderEventTarget extends EventTarget {
  result: string;
}

interface FileReaderEvent extends Event {
  target: EventTarget;
  getMessage(): string;
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-inscription',
  templateUrl: './inscription.component.html',
  styleUrls: ['./inscription.component.css']
})
export class InscriptionComponent implements OnInit, AfterViewInit,OnChanges {
  cities = [
    { value: 'france', viewValue: 'France' },
    { value: 'allemagne', viewValue: 'Allemagne ' },
    { value: 'belgique', viewValue: 'Belgique' },
    { value: 'espagne', viewValue: 'Espagne' },
    { value: 'irlande', viewValue: 'Irlande' },
    { value: 'italie', viewValue: 'Italie' },
    { value: 'royaume-unis', viewValue: 'Royaumes Unis' },
  ];
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  @ViewChild(SlideControlComponent, { static: true })
  slide: SlideControlComponent;

  public controlInput: ControlInput;

  private query: VertifyQuery;

  matcher = new MyErrorStateMatcher();

  type: FormGroup;

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  public _apikey: string;

  public _mail: string;
  public _nom: string;
  public _prenom: string;
  public _fixe: string;
  public _portable: string;
  public _adresse: string;
  public _complements: string;
  public _cp: string;
  public _ville: string;
  public _pays: string;
  public _poste: string;

  @Input() identifiant: string;
  @Input() pass: string;

  public _code: string;
  public _pass: string;
  public _passConfirm: string;

  public errorMail: string;
  public errorCode: string;
  public errorPass: string;

  public _consentement: string;
  public consent: boolean;

  public vue: boolean;

  public candidat: UserInfo;

  public id: number;
  public title: string;
  @Input() source: string;
  public num: string;

  public photo: string;
  public cv: string;
  public lm: string;

  public _deja: boolean;
  errorLogin = false;

  public _civilite: string;

  public isVertical: boolean = false;

  public controlForm: FormGroup;
  public haveConsent = false;
  public indexTab: number = 0;
  config = ConfigService.GetItem;
  sanitizer: any;
  @ViewChild('stepper') private myStepper: MatStepper;
  public authService: any
  private routeSub: any;
  constructor(private encdec: EncryptDecryptService, public param: VariablesGlobales,
    public dialogRef: MatDialogRef<InscriptionComponent> = undefined,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _formBuilder: FormBuilder,
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private route: ActivatedRoute,
    private router: Router,
    private _sanitizer: DomSanitizer
    ) {
    

    this.route.queryParams.subscribe(params => {
      this.id = params['id']; // --> Name must match wanted parameter
      this.source = params['source'];
      this.num = params['num'];
      if (!this.id && !isNaN(Number(this.num))) {
        this.id = Number(this.num);
        this.num = null;
      }
    });

    ConfigService.str.asObservable().subscribe((value) => {
      $('.moving-tab').css({
        'background-color': this.config('moving-tab')?.style,
      });
    });

    if (data?.idannonce)
      this.id = data?.idannonce;
    if (data?.intitule)
      this.title = data?.intitule;
    if (data?.source)
      this.source = data?.source;

    if (this.num) {
      this.http.get('https://api2.sitederecrutement.com/Home/GetIdBySource?apikey=' + localStorage.getItem('apikey') + '&mail=' + this.num, { responseType: 'text' }).subscribe(
        result => {
          const jsonData = this.encdec.getDecrypt(result);
          const obj = JSON.parse(jsonData);
          this.title = obj.intitule;
          this.id = obj.idannonce;
          this.source = obj.source;
        }
      );
    }
    else if (this.id && !this.title)
      this.http.get('https://api2.sitederecrutement.com/Home/GetAnnonce?apikey=' + localStorage.getItem('apikey') + '&id=' + this.id, { responseType: 'text' }).subscribe(
        result => {
          const jsonData = this.encdec.getDecrypt(result);
          this.title = JSON.parse(jsonData).intitule;
        }
      );

    this.http.get('https://api2.sitederecrutement.com/Home/GetConsentement?apikey='+ localStorage.getItem('apikey'), { responseType: 'text' }).subscribe(
      result => {
        const jsonData = this.encdec.getDecrypt(result);     
        let jsonObject: any = JSON.parse(jsonData.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;').replace(/(?:\\[rn]|[\r\n]+)+/g, ''));
        this._consentement = jsonObject.result;
      }
    );

    this.controlForm = new FormGroup({
      nom: new FormControl(this._nom, [
        Validators.required,
        Validators.maxLength(50)
      ]),
      prenom: new FormControl(this._prenom, [
        Validators.required,
        Validators.maxLength(50)
      ]),
      email: new FormControl(this._mail, [
        Validators.required,
        Validators.pattern('(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))')
      ]),
      consent: new FormControl(null, [
        Validators.nullValidator
      ]),
      cv: new FormControl(this.cv, [
        Validators.required
      ]),
      telMob: new FormControl(this._portable, [
        Validators.nullValidator
      ])
    });

    this.authService = JSON.parse(localStorage.getItem('currentUser'));
    if (this.authService) {
      this.http.get('https://api2.sitederecrutement.com/Home/GetCandidate?apikey=' + localStorage.getItem('apikey') + '&login=' + this.authService?.candidat_api, { responseType: 'text' }).subscribe(
        (result) => {
          const obj = JSON.parse(this.encdec.getDecrypt( result));
          this.controlForm.get('email').setValue(obj.can_mail);
          this.controlForm.get('nom').setValue(obj.can_nom);
          this.controlForm.get('prenom').setValue(obj.can_prenom);
          this._adresse = obj.can_adresse;
          this._complements = obj.can_adresse2;
          this._cp = obj.can_codepostale;
          this._ville = obj.can_ville;
          this._pays = obj.can_pays;
          this._civilite = obj.can_civilite;
        }
      );
    }
  }

  onDeja() : void {
    this._deja = true;
  }

  private result = false;
  onConnect(): boolean {
    var test = false;
    this.http.get('https://api2.sitederecrutement.com/Home/getcandidate?apikey=' + localStorage.getItem('apikey') + '&login=' + this.identifiant + '&pass=' + sha256(this.pass), { responseType: "text" })
      .subscribe(
        (result) => {
          //console.log(this.encdec.getDecrypt( 'dHd9eAafwk+qO0AN5eQalA=='));
          if (this.encdec.getDecrypt( result) !== 'null') {
            let data = this.encdec.getDecrypt( result);
            //console.log(data);
            let obj = JSON.parse(data);
            const user: User = {
              idcandidat: obj.idcandidat,
              can_echec_connexion: obj.can_echec_connexion,
              can_echec_connexion_date: obj.can_echec_connexion_date,
              can_echec_connexion_heure: obj.can_echec_connexion_heure,
              can_passe_date: obj.can_passe_date,
              candidat_api: obj.can_session_api,
              can_passe_modif: obj.can_passe_modif,
              photo: obj.photo,
              consentement: obj.consentement,
              nom: obj.can_nom,
              prenom: obj.can_prenom,
              mail: obj.can_mail,
              portable: obj.can_tel_mob
            }

            this.haveConsent = obj.consentement;

            this.controlForm.get('email').setValue(obj.can_mail);
            this.controlForm.get('nom').setValue(obj.can_nom);
            this.controlForm.get('prenom').setValue(obj.can_prenom);
            this._adresse = obj.can_adresse;
            this._complements = obj.can_adresse2;
            this._cp = obj.can_codepostale;
            this._ville = obj.can_ville;
            this._pays = obj.can_pays;
            this._civilite = obj.can_civilite;

            // console.log(user.candidat_api);
            localStorage.setItem('currentUser', JSON.stringify(user));
            test = true;
          }
          else {
            this.errorLogin = true;
            test = false;
          }
        },
        error => {
          console.error(error);
          this.errorLogin = true;
          test = false;
        });
    //console.log("result = " + test);
    return test;
  }

  ngOnInit(): void {
    this.routeSub = this.route.params.subscribe(params => {
      this._apikey = params['cc'];
    });
    this.controlInput = new ControlInput(
      'https://api.xfunction.cn/slide/get',
      'https://api.xfunction.cn/slide/vertify',
      true
    );

  }

  private reset() {
    this.query.move = undefined;
    this.query.action = [];
    this.slide.reset();
  }

  successMatch(query: VertifyQuery) {
    //console.log(query);
    this.query = query;
  }

  ngOnChanges(changes: SimpleChanges) {
    const input = $(this);

    if (input[0].files && input[0].files[0]) {
      const reader: any = new FileReader();

      reader.onload = function (e: any) {
        $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
      };
      reader.readAsDataURL(input[0].files[0]);
    }
    $('.moving-tab').css({
      'background-color': this.config('moving-tab')?.style,
    });
    let wizard = document.querySelector('.card-wizard');
    (wizard.querySelector('.moving-tab') as HTMLElement).style.backgroundColor = this.config('moving-tab')?.style;
  }

  changeTab(index: number) {
    if (index === 1 && this._deja && !this.authService && !this.haveConsent) {
      if (!this.onConnect()) {
        return;
      }
    }
      
    this.changeIndex(index);
    if (index === 0) {
      if (this._deja) {
        if (!this.authService && !this.haveConsent)
          (document.querySelector('#account') as HTMLElement).style.display = 'none';
        (document.querySelector('#address') as HTMLElement).style.display = 'none';
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#conn') as HTMLElement).style.display = 'block';
      } else {
        if (!this.authService && !this.haveConsent)
          (document.querySelector('#account') as HTMLElement).style.display = 'none';
        (document.querySelector('#address') as HTMLElement).style.display = 'none';
        (document.querySelector('#about') as HTMLElement).style.display = 'block';
      }
    } else if (index === 1 && !this.authService && !this.haveConsent) {
      if (this._deja) {
        (document.querySelector('#address') as HTMLElement).style.display = 'none';
        (document.querySelector('#about') as HTMLElement).style.display = 'block';
        (document.querySelector('#account') as HTMLElement).style.display = 'none';
        (document.querySelector('#conn') as HTMLElement).style.display = 'none';
      } else {
        (document.querySelector('#address') as HTMLElement).style.display = 'none';
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#account') as HTMLElement).style.display = 'block';
      }
    } else if (index === 1 && (this.authService || this.haveConsent)) {
      if (this._deja) {
        (document.querySelector('#address') as HTMLElement).style.display = 'none';
        (document.querySelector('#about') as HTMLElement).style.display = 'block';
        (document.querySelector('#conn') as HTMLElement).style.display = 'none';
      } else {
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#address') as HTMLElement).style.display = 'block';
      }
    } else if (index === 2 && (this.authService || this.haveConsent)) {
      if (this._deja) {
        (document.querySelector('#address') as HTMLElement).style.display = 'block';
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#conn') as HTMLElement).style.display = 'none';
      } else {
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#address') as HTMLElement).style.display = 'block';
      }
    } else if (index === 2) {
      if (this._deja) {
        (document.querySelector('#address') as HTMLElement).style.display = 'none';
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#account') as HTMLElement).style.display = 'block';
        (document.querySelector('#conn') as HTMLElement).style.display = 'none';
      } else {
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#account') as HTMLElement).style.display = 'none';
        (document.querySelector('#address') as HTMLElement).style.display = 'block';
      }
    } else if (index === 3) {
      if (this._deja) {
        (document.querySelector('#address') as HTMLElement).style.display = 'block';
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#account') as HTMLElement).style.display = 'none';
        (document.querySelector('#conn') as HTMLElement).style.display = 'none';
      }
    } else if (index === 3 && (this.authService || this.haveConsent)) {
      if (this._deja) {
        (document.querySelector('#address') as HTMLElement).style.display = 'block';
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#conn') as HTMLElement).style.display = 'none';
      } else {
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#address') as HTMLElement).style.display = 'block';
      }
    } else {
      if (this._deja) {
        (document.querySelector('#account') as HTMLElement).style.display = 'none';
        (document.querySelector('#address') as HTMLElement).style.display = 'none';
        (document.querySelector('#about') as HTMLElement).style.display = 'none';
        (document.querySelector('#conn') as HTMLElement).style.display = 'block';
      } else {
        (document.querySelector('#account') as HTMLElement).style.display = 'none';
        (document.querySelector('#address') as HTMLElement).style.display = 'none';
        (document.querySelector('#about') as HTMLElement).style.display = 'block';
      }
    }
    
  }

  changeIndex(index) {
    this.indexTab = index;
    if (this._deja) {
      if (index === 0) {
        this.controlForm.controls['nom'].clearValidators();
        this.controlForm.controls['nom'].updateValueAndValidity();
        this.controlForm.controls['prenom'].clearValidators();
        this.controlForm.controls['prenom'].updateValueAndValidity();
        this.controlForm.controls['email'].clearValidators();
        this.controlForm.controls['email'].updateValueAndValidity();
        this.controlForm.controls['cv'].clearValidators();
        this.controlForm.controls['cv'].updateValueAndValidity();
        this.controlForm.controls['consent'].clearValidators();
        this.controlForm.controls['consent'].updateValueAndValidity();
      } else if (index === 1) {
        this.controlForm.controls['nom'].setValidators([Validators.required]);
        this.controlForm.controls['nom'].updateValueAndValidity();
        this.controlForm.controls['prenom'].setValidators([Validators.required]);
        this.controlForm.controls['prenom'].updateValueAndValidity();
        this.controlForm.controls['email'].setValidators([Validators.required]);
        this.controlForm.controls['email'].updateValueAndValidity();
        this.controlForm.controls['cv'].setValidators([Validators.required]);
        this.controlForm.controls['cv'].updateValueAndValidity();
      } else if (index === 2 && !this.authService && !this.haveConsent) {
        this.controlForm.controls['consent'].setValidators([Validators.requiredTrue]);
        this.controlForm.controls['consent'].updateValueAndValidity();
      }
    } else {
      if (index === 0) {
        this.controlForm.controls['consent'].clearValidators();
        this.controlForm.controls['consent'].updateValueAndValidity();
      } else if (index === 1 && !this.authService && !this.haveConsent) {
        this.controlForm.controls['consent'].setValidators([Validators.requiredTrue]);
        this.controlForm.controls['consent'].updateValueAndValidity();
      }
    }


    let $total = document.querySelectorAll('.wizard-navigation li').length;
    let $current = index + 1;
    (document.querySelector('.main-panel') as HTMLElement).scrollTop = 0;
    const $wizard = document.querySelector('.card-wizard');

    // If it's the last tab then hide the last button and show the finish instead
    if ($current >= $total) {
      $($wizard).find('.btn-next').hide();
      $($wizard).find('.btn-finish').show();
    } else {
      $($wizard).find('.btn-next').show();
      $($wizard).find('.btn-finish').hide();
    }

    const button_text = document.querySelector('.wizard-navigation li:nth-child(' + $current + ') a').firstChild.textContent;

    setTimeout(function () {
      document.querySelector('.moving-tab').innerHTML = button_text;
    }, 150);

    $total = $wizard.querySelectorAll('.nav li').length;
    let $li_width = 100 / $total;

    let total_steps = $wizard.querySelectorAll('.nav li').length;
    let move_distance = $wizard.clientWidth / total_steps;
    let index_temp = index;
    let vertical_level = 0;

    let mobile_device = $(document).width() < 600 && $total > 3;

    if (mobile_device) {
      move_distance = $wizard.clientWidth / 2;
      index_temp = index % 2;
      $li_width = 50;
    }

    $wizard.querySelectorAll('.nav li').forEach(x => (x as HTMLElement).style.width =  $li_width + '%');

    let step_width = move_distance;
    move_distance = move_distance * index_temp;

    $current = index + 1;

    if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
      move_distance -= 8;
    } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
      move_distance += 8;
    }

    if (mobile_device) {
      let x: any = index / 2;
      vertical_level = parseInt(x);
      vertical_level = vertical_level * 38;
    }

    ($wizard.querySelector('.moving-tab') as HTMLElement).style.width = step_width + 'px';
    ($wizard.querySelector('.moving-tab') as HTMLElement).style.transform = 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)' ;
    ($wizard.querySelector('.moving-tab') as HTMLElement).style.transition = 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const e = document.querySelector("#moving-tab");
    document.querySelector('.card-wizard .wizard-navigation').removeChild(e);
    this.ngAfterViewInit();
  }

  pictureChange(files) {
    if (files && files[0]) {
      const reader = new FileReader();
      const reader2 = new FileReader();

      reader.onload = this.pictureFinal.bind(this);
      reader.readAsArrayBuffer(files[0]);

      reader2.onload = this.picturePreview.bind(this);
      reader2.readAsDataURL(files[0]);
    }
  }

  picturePreview(e) {
    $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
  }

  pictureFinal(e) {
    var buffer = e.target.result;
    //var uint8 = new Uint8Array(binaryString);
    //var result = Array.from(uint8);
    var bs4String = this._arrayBufferToBase64(buffer);
    this.photo = bs4String;
  }

  cvChange(files) {
    if (files && files[0]) {
      const reader = new FileReader();

      reader.onload = this.cvFinal.bind(this);
      reader.readAsArrayBuffer(files[0]);
    }
  }

  loader = false;

  cvFinal(e) {
    this.loader = true;
    var buffer = e.target.result;
    var bs4String = this._arrayBufferToBase64(buffer);
    this.cv = bs4String;
    let formData = new FormData();
    formData.append('datas', bs4String);
    this.http.post('https://api2.sitederecrutement.com/Home/GetSemantis?apikey=' + localStorage.getItem('apikey'), formData, { responseType: 'text' }).subscribe(
      result => {
        if (result) {
          let data = result.replace('/* Curriculum Vitae export data - SEMIS-CV V5.  iso-8859-1  */', '').replace('/* English level : 1 (notions) to 4 (bilingual) */', '').split('&quot;').join('"');
          let obj = JSON.parse(data);

          //if (obj?.resume?.doubt[0] === '0') {
          //  this.controlForm.get('nom').setValue(obj.resume.identity.surname);
          //}        
          //if (obj?.resume?.doubt[1] === '0')
          //  this.controlForm.get('prenom').setValue(obj.resume.identity['first-name']);
          if (obj?.resume?.doubt[2] === '0')
            this._cp = obj.resume.identity.contacts.address['zip-code'];
          if (obj?.resume?.doubt[3] === '0') {
            this._adresse = obj.resume.identity.contacts.address.line1;
            this._complements = obj.resume.identity.contacts.address.line2;
          }
          if (obj?.resume?.doubt[4] === '0')
            this._ville = obj.resume.identity.contacts.address.city;
          if (obj?.resume?.doubt[5] === '0')
            this._ville = obj.resume.identity.contacts.address.city;
          if (obj?.resume?.doubt[8] === '0')
            this._fixe = obj.resume.identity.contacts.phone;
          if (obj?.resume?.doubt[9] === '0')
            this.controlForm.get('telMob').setValue(obj.resume.identity.contacts.phone2);

          this._civilite = obj?.resume?.identity?.quality === "Mr" ? 'Monsieur' : 'Madame';
        }

        this.loader = false;
      },
      error => {
        console.error(error);
        this.loader = false;
      }
    );
    this.controlForm.get('cv').setValue(bs4String);
  }

  lmChange(files) {
    if (files && files[0]) {
      const reader = new FileReader();

      reader.onload = this.lmFinal.bind(this);
      reader.readAsArrayBuffer(files[0]);
    }
  }

  lmFinal(e) {
    var buffer = e.target.result;
    //var uint8 = new Uint8Array(binaryString);
    //var result = Array.from(uint8);
    var bs4String = this._arrayBufferToBase64(buffer);
    this.lm = bs4String;
  }

  cvSuppr() {
    this.cv = undefined;
  }

  lmSuppr() {
    this.lm = undefined;
  }

  ngAfterViewInit():void {
    let total = document.querySelectorAll('.wizard-navigation li').length;
    let wizard = document.querySelector('.card-wizard');

    let first_li = document.querySelector('.wizard-navigation li').firstChild.textContent;
    let moving_div = '<div class="moving-tab" id="moving-tab">' + first_li + '</div>';
    document.querySelector('.card-wizard .wizard-navigation').insertAdjacentHTML('beforeend', moving_div);

    total = wizard.querySelectorAll('.nav li').length;
    let li_width = 100 / total;

    let total_steps = wizard.querySelectorAll('.nav li').length;
    let move_distance = wizard.clientWidth / total_steps;
    let index_temp = 0;
    let vertical_level = 0;

    let mobile_device = window.innerWidth < 600 && total > 3;

    if (mobile_device) {
      move_distance = wizard.clientWidth / 2;
      index_temp = 0 % 2;
      li_width = 50;
    }

    wizard.querySelectorAll('.nav li').forEach(x => (x as HTMLElement).style.width = li_width + '%');

    let step_width = move_distance;
    move_distance = move_distance * index_temp;

    let $current = 0 + 1;

    if ($current == 1 || (mobile_device == true && (0 % 2 == 0))) {
      move_distance -= 8;
    } else if ($current == total_steps || (mobile_device == true && (0 % 2 == 1))) {
      move_distance += 8;
    }

    if (mobile_device) {
      let x: any = 0 / 2;
      vertical_level = parseInt(x);
      vertical_level = vertical_level * 38;
    }

    (wizard.querySelector('.moving-tab') as HTMLElement).style.width = step_width + 'px';
    $('.moving-tab').css({
      'background-color': this.config('moving-tab')?.style,
    });
    $('.moving-tab').css({
      'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
      'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

    });
    $('.moving-tab').css('transition', 'transform 0s');
  }

  onSubmit() {
    const profil: Profil = {
      profil_pj1: undefined,
      profil_pj1_nom: undefined,
      profil_pj2: undefined,
      profil_pj2_nom: undefined,
      profil_titre: this._poste
    }
    if (this.cv) {
      profil.profil_pj1 = this.cv;
      profil.profil_pj1_nom = 'CV';
    }
    if (this.lm) {
      profil.profil_pj2 = this.lm;
      profil.profil_pj2_nom = 'LM';
    }
    const userInfo: UserInfo = {
      can_nom: this.controlForm.get('nom')?.value,
      can_prenom: this.controlForm.get('prenom')?.value,
      can_mail: this.controlForm.get('email')?.value,
      can_ville: this._ville,
      can_pays: this._pays,
      can_adresse1: this._adresse,
      can_adresse2: this._complements,
      can_tel_dom: this._fixe,
      can_tel_mob: this.controlForm.get('telMob')?.value,
      can_codepostale: this._cp,
      can_civilite: this._civilite,
      consentement: true,
      idcandidat: localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser'))?.idcandidat : '',
      profil: profil,
      photo: this.photo
    }

    //console.log(userInfo);

    let data = this.encdec.getEncrypt( JSON.stringify(userInfo));
    let formData = new FormData();
    formData.append('datas', data);
    this.http.post('https://api2.sitederecrutement.com/Home/updatecandidate?apikey=' + localStorage.getItem('apikey'), formData, { responseType: "text" }).subscribe(
      (result) => {
        if (result.includes("Error:")) {
          console.error(result);
        }
        else if (this.encdec.getDecrypt(result) !== 'null') {

          let data = this.encdec.getDecrypt( result);
          let obj = JSON.parse(data);
          //console.log(obj);
          const user: User = {
            idcandidat: obj.idcandidat,
            can_echec_connexion: obj.can_echec_connexion,
            can_echec_connexion_date: obj.can_echec_connexion_date,
            can_echec_connexion_heure: obj.can_echec_connexion_heure,
            can_passe_date: obj.can_passe_date,
            candidat_api: obj.can_session_api,
            can_passe_modif: obj.can_passe_modif,
            photo: obj.photo,
            consentement: obj.consentement,
            nom: obj.can_nom,
            prenom: obj.can_prenom,
            mail: obj.can_mail,
            portable: obj.can_tel_mob
          }
          localStorage.setItem('currentUser', JSON.stringify(user));

          if (this.id > 0) {
            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = today.getFullYear();
            const reponse: Reponse = {
              idcandidat: obj.idcandidat,
              repform_date: dd + '/' + mm + '/' + yyyy,
              repform_source: this.source,
              repform_langue: 'fr',
              idannonce: this.id,
              repform_piece_jointe1: null,
              repform_pj1_nom: null,
              repform_piece_jointe2: null,
              repform_pj2_nom: null,
            }
            if (this.cv) {
              reponse.repform_piece_jointe1 = this.cv;
              reponse.repform_pj1_nom = 'CV';
            }
            if (this.lm) {
              reponse.repform_piece_jointe2 = this.lm;
              reponse.repform_pj2_nom = 'LM';
            }
            data = this.encdec.getEncrypt( JSON.stringify(reponse));
            formData = new FormData();
            formData.append('datas', data);
            this.http.post('https://api2.sitederecrutement.com/Home/updatereponse?apikey=' + localStorage.getItem('apikey'), formData, { responseType: "text" }).subscribe(
              (result) => {
                //console.log(result);
              }
            )
          }
          if (this.dialogRef)
            this.dialogRef.close({});
          if (this.authService) {
            this.param.editPasswordForced = false;
            this.param.editDossier = false;
          } else {
            this.param.editPasswordForced = true;
            this.param.editDossier = true;
          }
          swal.fire({
            title: "Félicitations !",
            text: "Merci d’avoir postulé pour rejoindre notre entreprise 😊 . Votre candidature est enregistrée. Vous allez recevoir un accusé de réception avec votre identifiant par email. Merci de prendre quelques minutes de plus pour créer votre compte et compléter les informations facultatives dont a besoin notre équipe avant de vous contacter.Vous pourrez aussi créer des Job Alertes pour recevoir nos dernières annonces par email ou SMS ou postuler facilement aux nouvelles opportunités d’emploi avec vos codes personnels.",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-rose",
            },
            icon: "success",
            iconColor: 'd '
          });
          this.router.navigate(['profil']);
        }
      }
    )
  }

  onNoClick() {
    if (this.dialogRef)
      this.dialogRef.close({});
  }
  safeCss(style) {
    return this._sanitizer.bypassSecurityTrustStyle(style);
  }
  _arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

}

interface Result {
  error: string;
}

interface UserInfo {
  can_prenom: string;
  can_nom: string;
  can_mail: string;
  can_ville: string;
  can_pays: string;
  can_adresse1: string;
  can_adresse2: string;
  can_codepostale: string;
  can_tel_mob: string;
  can_tel_dom: string;
  can_civilite: string;
  consentement: boolean;
  idcandidat: string;
  profil: Profil;
  photo: string;
}

interface Profil {
  profil_pj1: string;
  profil_pj1_nom: string;
  profil_pj2: string;
  profil_pj2_nom: string;
  profil_titre: string;
}

interface Reponse {
  idcandidat: string;
  repform_date: string;
  idannonce: number;
  repform_source: string;
  repform_piece_jointe1: string;
  repform_piece_jointe2: string;
  repform_pj1_nom: string;
  repform_pj2_nom: string;
  repform_langue: string;
}

@Directive({ selector: '[after-if]' })
export class AfterIfDirective implements AfterContentInit {
  @Output('after-if')
  public after: EventEmitter<void> = new EventEmitter<void>();

  public ngAfterContentInit(): void {
    // timeout helps prevent unexpected change errors
    setTimeout(() => this.after.next());
  }
}
